/* Deadtree custom JS — loaded site-wide from the header.
   Wires the footer newsletter form (a static form with no action) to
   Shopify's customer/newsletter signup so it actually captures subscribers. */
(function () {
  function wire() {
    var form = document.querySelector('.dt-footer-wrap form.signup-row');
    if (!form) return;

    // Success state after Shopify redirects back with ?customer_posted=true
    if (/[?&]customer_posted=true/.test(window.location.search)) {
      var msg = document.createElement('p');
      msg.className = 'signup-msg';
      msg.textContent = "Thanks — you're on the list! We'll keep you posted on new arrivals, restocks and sales.";
      msg.style.cssText = 'color:#7C9464;font-size:14px;margin:0;';
      form.parentNode.insertBefore(msg, form);
      form.style.display = 'none';
      return;
    }

    // Make the form actually submit to Shopify's signup endpoint
    form.removeAttribute('onsubmit');
    form.onsubmit = null;
    form.setAttribute('method', 'post');
    form.setAttribute('action', '/contact#contact_form');
    form.setAttribute('accept-charset', 'UTF-8');

    var email = form.querySelector('input[type="email"]');
    if (email) {
      email.setAttribute('name', 'contact[email]');
      email.required = true;
    }

    function addHidden(name, value) {
      if (!form.querySelector('[name="' + name + '"]')) {
        var i = document.createElement('input');
        i.type = 'hidden';
        i.name = name;
        i.value = value;
        form.appendChild(i);
      }
    }
    addHidden('form_type', 'customer');
    addHidden('utf8', '✓');
    addHidden('contact[tags]', 'newsletter');
    addHidden('return_to', window.location.pathname);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wire);
  } else {
    wire();
  }
})();

/* Deadtree — live suggestions for the black top-bar search box. */
(function () {
  var DT_TP_CSS = [
    ".dt-topbar-predictive{position:absolute;top:calc(100% + 4px);left:0;right:0;background:#fff;border:1px solid #e4e0d6;border-radius:2px;box-shadow:0 20px 44px rgba(0,0,0,.22);max-height:72vh;overflow-y:auto;z-index:9999;display:none;text-align:left;padding:6px 8px;color:#1B1A17;}",
    ".dt-topbar-predictive .predictive-search__results-list{display:block!important;margin:0;padding:0;list-style:none;}",
    ".dt-topbar-predictive .predictive-search__heading{font-family:'Poppins',sans-serif;font-size:11px;letter-spacing:.14em;text-transform:uppercase;color:#8a8578;margin:10px 6px 4px;}",
    ".dt-topbar-predictive .search__product-loop{display:block!important;margin:0;padding:0;list-style:none;}",
    ".dt-topbar-predictive .product-index{width:100%!important;max-width:none!important;margin:0!important;padding:0!important;}",
    ".dt-topbar-predictive .product-loop__item{display:flex!important;align-items:center;gap:12px;padding:8px 6px!important;border-bottom:1px solid #f0ede5;margin:0!important;}",
    ".dt-topbar-predictive .product-loop__item:hover{background:#faf8f3;}",
    ".dt-topbar-predictive .product-image{width:52px;min-width:52px;flex:0 0 52px;margin:0!important;}",
    ".dt-topbar-predictive .product-loop__img-wrapper{margin:0!important;padding:0!important;}",
    ".dt-topbar-predictive .product-image img{width:52px!important;height:52px!important;object-fit:contain!important;position:static!important;}",
    ".dt-topbar-predictive .box-ratio{padding:0!important;height:auto!important;}",
    ".dt-topbar-predictive .product-loop__badge-icon,.dt-topbar-predictive .product-loop__vendor,.dt-topbar-predictive .product-loop__cta,.dt-topbar-predictive .product-loop__price--compare,.dt-topbar-predictive .product-loop__price--savings{display:none!important;}",
    ".dt-topbar-predictive .product-loop__info-wrapper{flex:1;padding:0!important;margin:0!important;text-align:left!important;}",
    ".dt-topbar-predictive .product-loop__title{font-family:'Poppins',sans-serif;font-size:13px;line-height:1.3;margin:0;color:#1B1A17;}",
    ".dt-topbar-predictive .product-loop__info_bottom-wrapper{margin-left:auto;text-align:right;}",
    ".dt-topbar-predictive .product-loop__price{font-family:'Poppins',sans-serif;font-size:13px;font-weight:600;color:#5A6E45;padding:0!important;white-space:nowrap;}",
    ".dt-topbar-predictive .predictive-search__list-item{list-style:none;}",
    ".dt-topbar-predictive .predictive-search__item{display:block;padding:7px 6px;font-size:13px;color:#1B1A17;text-decoration:none;}",
    ".dt-topbar-predictive .predictive-search__item:hover{background:#faf8f3;}",
    ".dt-topbar-predictive .predictive-search__list-item--search{padding:8px 6px 4px;}",
    ".dt-topbar-predictive .predictive-search__list-item--search .button{display:block;width:100%;background:#5A6E45;color:#fff;border:none;padding:10px;border-radius:2px;font-family:'Poppins',sans-serif;font-size:12px;letter-spacing:.08em;text-transform:uppercase;cursor:pointer;}"
  ].join('');

  function initTopbarSearch() {
    var form = document.querySelector('.dt-topbar form[role="search"]');
    if (!form || form.dataset.dtPredictiveWired) return;
    var input = form.querySelector('input[name="q"]');
    if (!input) return;
    form.dataset.dtPredictiveWired = '1';
    form.style.position = 'relative';

    var results = document.createElement('div');
    results.className = 'dt-topbar-predictive';
    results.setAttribute('role', 'listbox');
    form.appendChild(results);

    if (!document.getElementById('dt-topbar-predictive-css')) {
      var css = document.createElement('style');
      css.id = 'dt-topbar-predictive-css';
      css.textContent = DT_TP_CSS;
      document.head.appendChild(css);
    }

    var ROUTE = '/search/suggest';
    var timer = null;

    function closeBox() { results.style.display = 'none'; results.innerHTML = ''; }
    function openBox() { results.style.display = 'block'; }

    function run(term) {
      fetch(ROUTE + '?q=' + encodeURIComponent(term) + '&section_id=predictive-search')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          if (input.value.trim() !== term) return;
          var node = new DOMParser().parseFromString(html, 'text/html')
            .querySelector('#shopify-section-predictive-search');
          var markup = node ? node.innerHTML.trim() : '';
          if (markup) { results.innerHTML = markup; openBox(); } else { closeBox(); }
        })
        .catch(function () { closeBox(); });
    }

    input.setAttribute('autocomplete', 'off');
    input.addEventListener('input', function () {
      var term = input.value.trim();
      if (timer) clearTimeout(timer);
      if (term.length < 2) { closeBox(); return; }
      timer = setTimeout(function () { run(term); }, 250);
    });
    input.addEventListener('focus', function () {
      if (input.value.trim().length >= 2 && results.innerHTML) openBox();
    });
    input.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeBox(); });
    document.addEventListener('click', function (e) { if (!form.contains(e.target)) closeBox(); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTopbarSearch);
  } else {
    initTopbarSearch();
  }
})();

/* Deadtree — Our Story page: contour map behind the "Business is in their blood"
   intro (left third, subtle, fading toward the centre). Scoped to /pages/our-story. */
(function () {
  var p = location.pathname.toLowerCase();
  if (p !== '/pages/our-story' && p !== '/pages/our-story/') return;
  if (document.getElementById('dt-ourstory-contour')) return;
  var css =
    ".intro{position:relative;overflow:hidden;}" +
    ".intro > .inner{position:relative;z-index:1;}" +
    ".intro::before{content:'';position:absolute;top:0;left:0;bottom:0;width:42%;" +
    "background:url('https://cdn.shopify.com/s/files/1/0758/9006/5629/files/deadtree-contour.png?v=1786987430') left center/cover no-repeat;" +
    "mix-blend-mode:multiply;opacity:.5;" +
    "-webkit-mask-image:linear-gradient(to right,#000 0%,#000 42%,transparent 100%);" +
    "mask-image:linear-gradient(to right,#000 0%,#000 42%,transparent 100%);pointer-events:none;}" +
    "@media(max-width:560px){.intro::before{width:60%;opacity:.4;}}";
  var s = document.createElement('style');
  s.id = 'dt-ourstory-contour';
  s.textContent = css;
  document.head.appendChild(s);
})();
